import React from 'react'
import { useParams } from 'react-router-dom'
import apiService from 'services/api'
import CommonPage from 'components/DataExpansionComponents/Common/CommonPage'
import { ContactCompanyType } from 'models/contact_companies'
import { usePreferences } from 'context/preferences/PreferencesContext'

export default function ConvenienceDoorPage() {
  const urlParams = useParams()
  const convenienceID = urlParams.convenience_id!
  const { preferences } = usePreferences()

  const api = apiService()
  const { data, isLoading, isError, error } = api.useGetConvenienceDoor(
    parseInt(convenienceID)
  )

  return (
    <CommonPage
      uniqueCompanyTypeId={parseInt(convenienceID)}
      useGetCompany={{
        companyData: data,
        contactCompanyData: data?.chain_proxy,
        isLoading,
        isError,
        error,
      }}
      tableTypeSlug="convenience-doors"
      companyTypeSlug="convenience"
      breadcrumbs={[
        {
          title: 'Chain',
          breadcrumb: data?.cstore?.name,
          url: `/convenience/chain/${preferences?.company_type_prefix_map[ContactCompanyType.Convenience]}${data?.cstore?.chain_id}`,
        },
      ]}
      getFieldsFromData={(data) => {
        return {
          contactCompanyId: data?.chain_proxy.id,
          companyName: data?.cstore?.name,
          websiteAddress: data?.cstore?.website,
          phone: data?.cstore?.phone,
          address: {
            addressInfo: {
              fullAddress: data?.cstore?.address,
              city: data?.cstore?.city,
              state: data?.cstore?.state,
            },
            fullAddressInfo: data?.cstore?.address_info,
            addressUrl: data?.cstore?.place_url,
          },
        }
      }}
    />
  )
}
